import styled from "styled-components";

export const ClockLastLoginDefaultBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: auto 1.5rem 2rem 1.5rem;
    background-color: ${props => props.theme.colors.backgroundDark};
    padding: 1rem 1.6rem;
    border-radius: 4px;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        background-color: unset;
        margin: auto 0;
        align-self: flex-start;
        align-items: center;
        padding: 0;
    }
`;
